/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import TeamRegistrationForm from "./TeamRegistrationForm";
import FeaturesMatrix from "./FeaturesMatrix";
import {RiTeamLine, RiUser3Fill, RiUser3Line} from "react-icons/ri";
import SmallLoginForm from "../user/LoginForm";
import withNavigationHook from "../../hooks/withNavigationHook";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";

class RegisterTeam extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  componentDidMount() {
    const storedCustomer = sessionStorage.getItem("customer");
    const customer = storedCustomer ? JSON.parse(storedCustomer) : null;
    if (customer?.user?.accountRole) {
      this.props.navigation("/your-profile/team");
      return;
    }

    if (!sessionStorage.getItem("selectedPlan") || sessionStorage.getItem("selectedAccountType") !== "team") {
      this.props.navigation("/register/choose-your-plan");
    }
  }

  render() {
    return (
      <>
        <SeoNoIndex noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>group subscription</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="8">
                      <Card className="card shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-success rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-istanbul" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                <RiTeamLine color='#5e72e4' size="36"/>Group Subscription — Annual
                              </h2>
                            </Col>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase text-right">
                                &pound;300 per year
                              </h2>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            Register now to build, save and edit unlimited curated song-flows using all of our
                            {" "}{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value}{" "}
                            song books.
                          </p>
                          <TeamRegistrationForm/>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-warning rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-planet" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                <RiUser3Fill color='#5e72e4' size="36"/>&nbsp;Already have an account?
                              </h2>
                              <p className="description mt-3">
                                Sign in and build your curated song-flows
                              </p>
                            </Col>
                          </Row>
                          <SmallLoginForm/>
                        </CardBody>
                      </Card>
                      <br/>&nbsp;<br/>
                      <Card className="card shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-warning rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-planet" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                <RiUser3Line color='#5e72e4' size="36"/>Single User
                              </h2>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            Looking for an individual plan? Go back and choose Single User.
                          </p>
                          <Button
                              className="mt-4"
                              color="primary"
                              href="/register/choose-your-plan"
                          >
                            Choose single user
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col lg="8">
                      <Card className="card shadow border-0">
                        <CardBody className="py-5">
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                We take security seriously and never sell or misuse your data.
                              </h2>
                              <p className="description mt-3">
                                Learn more about our <a href="/security">Security &amp; Data Protection</a>.
                              </p>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        <FeaturesMatrix/>
        {/*</main>*/}
        
      </>
    );
  }
}

export default withNavigationHook(RegisterTeam);
